<div class="form-group {{ additionalClass }}">
  @if (label) {
    <label class="control-label mr-3" for="preview-selector">{{ label }}</label>
  }
  <button mat-stroked-button class="tw-bg-white item-selector" (click)="openDialog()" id="schedule-selector" type="button">
    @if (!selectedItem) {
      <span class="text-muted">Select or add a new schedule</span>
    }
    @else {
      <span class="tw-truncate">{{selectedItem.name}}</span>
    }
    <mat-icon svgIcon="chevron-down" class="tw-pl-2 medium" iconPositionEnd />
  </button>
</div>
